"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectEnrichAI = void 0;
const reselect_1 = require("reselect");
const main_1 = require("../../store/selectors/main");
exports.selectEnrichAI = (0, reselect_1.createSelector)(main_1.enrichSelector, ({ enrichAI }) => enrichAI);
